import React, { useState } from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import Footer from './footer';
import Pagination from './Pagination';

const Projects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 1; // Number of projects per page

  const projects = [
    {
      title: "Input Master Tool (Microsoft FDnE)",
      role: "Technical Lead",
      tech: "VSTO, .Net Core WebAPI, React, SSIS, SSAS, Azure DevOps",
      description: "As a Technical Lead, I architected and developed the Input Master Tool, a sophisticated solution for revenue planning and forecasting tailored for Microsoft’s internal finance teams. The tool integrates various advanced technologies to provide a seamless and efficient financial planning experience.",
      features: [
       {data:
       "Dynamic Template Creation",
       value:"The tool allows finance teams to dynamically create input templates on the fly. This feature is crucial for adapting to changing business requirements and provides the flexibility needed for accurate financial planning."
      },
      {data:
        "Comprehensive Configurations",
       value:"Users can apply complex configurations and set up precise allocations and calculations. This ensures that the financial data is tailored to specific business needs and scenarios, enhancing the accuracy of forecasts."
       },
       {data:
        "Data Publishing",
       value:"The tool publishes data to downstream systems efficiently, ensuring seamless data flow and integration across different platforms and departments. This streamlines the financial planning process and reduces the time needed for data handling."
       },
       {data:
        "Detailed Reporting",
       value:"It generates comprehensive reports that allow financial users to compare revenue, licenses, and Adjusted Gross Revenue (AGR). These reports provide critical insights and support data-driven decision-making."
       },
       {data:
        "Efficiency and Time Savings",
       value:"The tool has significantly streamlined the input template creation process, resulting in a 60% reduction in the time required for onboarding new templates and the rollover process. This time savings allows finance teams to focus on strategic analysis rather than administrative tasks."
       }
     
      ],
      techImpl: [

        {data:
          "VSTO (Visual Studio Tools for Office)",
         value:"Utilized for creating Office-based applications, ensuring seamless integration with Microsoft Excel, which is heavily used by finance teams."
         },
         {data:
          ".Net Core WebAPI",
         value:"Provides the backbone for the web services, enabling robust and scalable backend operations."
         },
         {data:
          "React",
         value:"Ensures a responsive and dynamic user interface, improving the user experience."
         },
         {data:
          "SSIS (SQL Server Integration Services)",
         value:"Facilitates data integration and transformation tasks, ensuring data consistency and accuracy."
         },
         {data:
          "SSAS (SQL Server Analysis Services)",
         value:"Used for online analytical processing and data mining, enhancing the tool's analytical capabilities."
         },
         {data:
          "Azure DevOps",
         value:"Supports continuous integration and deployment, ensuring that updates and improvements are delivered efficiently and reliably."
         },
         
    
      ],
      awards: [
        {data:
          "CFT FinStant Award",
         value:"This award recognizes the innovative and impactful contributions of the Input Master Tool to Microsoft’s financial planning processes."
         },
         {data:
          "CFT Growth Mindset Award",
         value:"This accolade highlights the tool’s embodiment of a growth mindset, reflecting continuous improvement and adaptation to meet evolving business needs."
         },
       
      ],
      
      hello: "The Input Master Tool has become an indispensable asset for the Microsoft finance teams, revolutionizing how revenue planning and forecasting are conducted. By integrating cutting-edge technologies and focusing on user-centric design, the tool not only enhances operational efficiency but also drives strategic business insights and decision-making."
      
    },
    {
      title: "Deal Analysis Tool (Microsoft CLTV Team)",
      role: "Technical Lead",
      tech: "VSTO, .Net Core WebAPI, SSAS, Azure DevOps",
      description: "As the Technical Lead, I designed and developed the Deal Analysis Tool (DAT) for Microsoft’s Customer Lifetime Value (CLTV) team. This sophisticated tool plays a crucial role in managing and evaluating deal escalations, enhancing the decision-making process for Licensing Executives (LEs) and Commercial Executives (CEs).",
      features: [
        {data:
          "Deal Scenario Modeling",
         value:"The DAT allows Licensing Executives (LEs) to model various deal scenarios, facilitating the approval or denial of deal escalations. This capability is essential when a Commercial Executive (CE) escalates a deal due to a customer’s request for a discount beyond their authorized limit."
         },
         {data:
          "Complex Calculations",
         value:"The tool integrates advanced calculation algorithms to evaluate the viability and impact of proposed deals. This ensures that every scenario is thoroughly analyzed and assessed based on various financial and business parameters."
         },
         {data:
          "Data Integration",
         value:"DAT pulls data from multiple sources, including APIs, OLAP cubes, and databases. This integration allows for comprehensive analysis and provides a holistic view of the deal’s context and potential outcomes."
         },
         {data:
          "Solution Consolidation",
         value:"By combining eight disparate solutions into one cohesive tool, the DAT simplifies and streamlines the deal and scenario creation process. This consolidation significantly reduces the time and effort required for deal management, enhancing overall efficiency."
         },
         {data:
          "Decision Support",
         value:"The tool supports Licensing Executives in making informed decisions by providing detailed insights and analysis. LEs can approve, deny, or re-escalate deals based on the data and calculations presented, ensuring that all deal decisions are well-supported and justified."
         }
      ],
      techImpl: [
        {data:
          "VSTO (Visual Studio Tools for Office)",
         value:"Employed for integrating with Microsoft Office applications, particularly Excel, to facilitate data input and reporting."
         },
         {data:
          ".Net Core WebAPI",
         value:"Serves as the backbone for the tool’s backend operations, ensuring robust and scalable web services."
         },
         {data:
          ".Net Core WebAPI",
         value:"Utilized for multidimensional analysis and data mining, enhancing the tool’s analytical capabilities and providing deeper insights."
         },
         {data:
          "Azure DevOps",
         value:"Supports continuous integration and deployment practices, ensuring that updates and enhancements are efficiently managed and delivered."
         }
       
      ],
      achievements: [
        {data:
          "Integration of Multiple Solutions",
         value:"The DAT effectively consolidates eight different existing solutions into one unified tool. This integration streamlines workflows and reduces complexity, resulting in a more efficient and user-friendly system."
         },
         {data:
          "Enhanced Efficiency",
         value:"By automating and optimizing the deal evaluation process, the DAT significantly reduces the time required for creating and editing deals and scenarios. This efficiency gains contribute to faster decision-making and improved operational performance."
         }
        
      
      ],
      awards: [
        {data:
          "CFT Quarterly Partnership Award",
         value:"The Deal Analysis Tool earned this prestigious award in recognition of its exceptional contribution to the Customer Lifetime Value team’s success. The award highlights the tool’s effectiveness in enhancing deal management processes and supporting strategic decision-making."
         }
      
      ],
      hello: "The Deal Analysis Tool has become an essential asset for managing deal escalations and modeling prospective scenarios. Through its advanced capabilities and integration of multiple data sources, the tool not only improves decision-making but also enhances overall operational efficiency within the CLTV team."

    },
    {
      title: "Console Market Share Tool (Microsoft CCG Finance Team)",
      role: "Technical Lead",
      tech: ".NET, SSIS, SSRS",
      description: "As the Technical Lead for the Console Market Share Tool (CMST) project, I was responsible for designing and developing an internal web application for the Microsoft (CCG) Finance team. The CMST is a critical tool for estimating and analyzing the market share of Microsoft’s gaming products, providing valuable insights through comparison with key competitors.",
      features: [
        {data:
          "Market Share Estimation",
         value:"The CMST enables accurate estimation of Microsoft's gaming products' market share by comparing them with competitors such as PS3, PS4, Will, and WilU. This functionality helps the finance team understand Microsoft's market position and make strategic decisions."
         },
         {data:
          "Forecast Unit Input",
         value:"Users can input forecast units for various reporting periods, including Budget, October Forecast, January Forecast, and April Forecast. This flexibility supports different forecasting cycles and ensures that projections are aligned with business needs."
         },
         {data:
          "Excel Data Integration",
         value:"The tool supports data input via Excel files, allowing users to upload large volumes of data efficiently. This feature streamlines the data entry process and minimizes manual input errors."
         },
         {data:
          "Detailed Reporting",
         value:"The CMST provides comprehensive reports and pivot tables generated through SQL Server Reporting Services (SSRS). These reports offer an in-depth view of the input data, facilitating detailed analysis and decision-making."
         },
         {data:
          "User-Friendly Data Handling",
         value:"A key feature of the tool is its ability to accept and process Excel data through a copy-and-paste functionality directly onto the web page. This innovative feature significantly reduces the time required for data upload and enhances user productivity."
         }

     
      ],
      techImpl: [
        {data:
          ".NET Framework",
         value:": Utilized for developing the web application’s backend and frontend components, ensuring a robust and scalable solution."
         },
         {data:
          "SSIS (SQL Server Integration Services)",
         value:"Employed for efficient data extraction, transformation, and loading (ETL) processes, ensuring smooth integration of data from various sources."
         },
         {data:
          "SSRS (SQL Server Reporting Services)",
         value:"Used to create and deliver detailed reports and dashboards, providing users with actionable insights and visualizations of the market share data."
         }
       
      ],
      achievements: [
        {data:
          "Enhanced Efficiency",
         value:"The implementation of Excel data copy-paste functionality greatly improved data handling efficiency, saving users significant time and reducing the complexity of data uploads."
         },
         {data:
          "Improved Accuracy",
         value:"By automating the data input and reporting processes, the CMST increased the accuracy of market share estimates and reporting, leading to more reliable insights."
         },
         {data:
          "Streamlined Workflow",
         value:"Consolidating various forecasting and reporting functionalities into a single platform streamlined the workflow and reduced the need for multiple systems, enhancing overall productivity."
         }
        
      ],
      awards: [
        {data:
          "Microsoft Excellence Award",
         value:"The Console Market Share Tool was honored with the Microsoft Excellence Award, recognizing its innovative design and substantial impact on improving market share analysis and data handling processes. This accolade reflects the tool’s effectiveness in enhancing operational efficiency and providing critical business insights."
         }
        
      ],
      hello: "The Console Market Share Tool has proven to be a vital asset for the CCG Finance team, delivering a comprehensive and efficient solution for market share estimation and reporting. Its user-centric design and advanced features have streamlined processes and contributed to more informed and strategic decision-making."

    },
    {
      title: "ClickNConvey (Microsoft CCG Finance Team)",
      role: "Technical Lead",
      tech: ".NET, Azure, Windows Schedulers",
      description: "ClickNConvey is an innovative hobby project I developed to streamline communication and enhance operational efficiency within the Microsoft (CCG) Finance team. The tool was designed to automate and simplify the process of notifying team members about the open and close dates of various tools, improving overall workflow and data management.",
      features: [
        {data:
          "Automated Notifications",
         value:"ClickNConvey automates the process of notifying users about the open and close dates for tools. This feature ensures that all relevant stakeholders are informed in a timely manner, reducing the need for manual notifications and minimizing the risk of overlooked deadlines."
         },
         {data:
          "Daily Audit Reports",
         value:": The tool generates comprehensive daily audit reports that detail which geographical regions have submitted their inputs and which are still pending. This feature provides a clear and real-time view of submission statuses, enabling quick identification of areas needing follow-up."
         },
         {data:
          "Summary Reports",
         value:"ClickNConvey produces summary reports that aggregate submission data and provide an overview of feed submission statuses. These reports offer valuable insights into the progress of submissions and help in assessing overall compliance and efficiency."
         },
         {data:
          "Excel Data Integration",
         value:"A standout feature of ClickNConvey is its ability to handle Excel data directly. Users can copy and paste data from Excel spreadsheets onto the web page, facilitating rapid and accurate data uploads. This feature significantly reduces the time required for data entry and enhances user convenience."
         }
       
      ],
      techImpl: [
        {data:
          ".NET Framework",
         value:"Utilized for building the core application, ensuring robust performance and seamless integration with other systems. The .NET framework supports the development of scalable and reliable web applications."
         },
         {data:
          "Azure",
         value:"Leveraged for cloud-based services and storage, enabling the tool to operate efficiently and scale according to user demands. Azure's cloud infrastructure supports the automation and reporting functionalities of ClickNConvey."
         },
         {data:
          "Windows Schedulers",
         value:"Employed to automate routine tasks and ensure timely execution of processes. Windows Schedulers manage scheduled tasks, such as generating daily reports and sending notifications, without manual intervention."
         }
       
      ],
      achievements: [
        {data:
          "Enhanced Communication Efficiency",
         value:"By automating notifications and reporting processes, ClickNConvey has significantly improved communication within the team. The tool's automation capabilities have streamlined workflows and reduced manual effort."
         },
         {data:
          "Time Savings",
         value:"The Excel data integration feature allows users to quickly and easily upload data, saving valuable time and reducing the complexity of data handling. This functionality has improved productivity and efficiency for users."
         },
         {data:
          "Comprehensive Reporting",
         value:"The tool's ability to generate detailed daily and summary reports provides a clear overview of submission statuses and tool usage. This comprehensive reporting supports better decision-making and operational effectiveness."
         }
       
      ],
      impact: "ClickNConvey has had a substantial positive impact on the CCG Finance team by simplifying communication processes and enhancing overall business value. Its automation, data integration, and reporting features have streamlined workflows, improved efficiency, and contributed to more effective management of tool submissions and updates."
    }
  ];

  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);
  const totalPages = Math.ceil(projects.length / projectsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-sm-12 col-lg-3 col-xl-3 col-md-3">
            <Sidebar />
          </div>
          <div className="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu />
            <div className="bostami-page-content-wrap">
              <section>
              
                <div className="section-wrapper pl-60 pr-60 pt-60">
                <div class="three">
                                <h1 class="">Projects</h1>
                                </div>
                  {currentProjects.map((project, index) => (
                    <div className="bostami-card-item bg-catkrill mt-5" key={index}>
                      <h4 className={`fw-bold project${index + 1}`}>{project.title}</h4>
                      <p className="text-muted mb-2 fw-bold">{project.role}</p>
                      <p className="text-muted mb-2 fw-bold" style={{ color: 'rgb(27, 116, 228)' }}>{project.tech}</p>
                      <p className="text-muted">{project.description}</p>
                      <hr />
                      <h4 className="fw-bold mt-5">Key Features and Functions:</h4>
                      {project.features.map((feature, i) => (
                        <p className="text-muted" key={i}><b>{feature.data}:</b>  {feature.value}</p>
                      ))}
                      <hr />
                      <h4 className="fw-bold mt-5">Technical Implementation:</h4>
                      {project.techImpl.map((tech, i) => (
                        <p className="text-muted" key={i}><b>{tech.data}:</b> {tech.value}</p>
                      ))}
                      {project.achievements && (
                        <>
                          <hr />
                          <h4 className="fw-bold mt-5">Key Achievements:</h4>
                          {project.achievements.map((achievement, i) => (
                            <p className="text-muted" key={i}><b>{achievement.data}:</b> {achievement.value}</p>
                          ))}
                        </>
                      )}
                      {project.awards && (
                        <>
                          <hr />
                          <h4 className="fw-bold mt-5">Awards and Recognition:</h4>
                          {project.awards.map((award, i) => (
                            <p className="text-muted" key={i}><b>{award.data}:</b> {award.value}</p>
                          ))}
                        </>
                      )}
                       {project.hello && (
                        <>
                          <hr />
                         
                          <h4 className="fw-bold mt-5"></h4>
                          <p className="text-muted">{project.hello}</p>
                        </>
                      )}
                      {project.impact && (
                        <>
                          <hr />
                         


                          <h4 className="fw-bold mt-5">Impact:</h4>
                          <p className="text-muted">{project.impact}</p>
                        </>
                      )}
                      <hr />
                    </div>
                  ))}
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </section>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
